import * as React from 'react';
import propz from 'propz';
import { History } from 'history';
import { AppUser } from 'Src/views/App/App';
import './Avatar.scss';

interface Props {
  user: AppUser;
  history: History;
  onClick: (event) => void;
}

export function Avatar(props: Props) {
  const { onClick } = props;
  const [hasImageError, setHasImageError] = React.useState(false);

  const imageSrc = String(propz.get(props, ['user', 'profile', 'avatar'], '') || '').trim();
  const firstName = String(propz.get(props, ['user', 'profile', 'firstName'], '') || '').trim();
  const lastName = String(propz.get(props, ['user', 'profile', 'lastName'], '') || '').trim();
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase() || 'U';
  const isImageVisible = imageSrc.length > 0 && !hasImageError;
  const sizingSeparator = imageSrc.indexOf('?') === -1 ? '?' : '&';

  React.useEffect(() => setHasImageError(false), [imageSrc]);

  return (
    <div className={`rounded-circle bAvatar${isImageVisible ? '' : ' bAvatar--initials'}`} onClick={onClick}>
      {isImageVisible ? (
        <img
          src={`${imageSrc}${sizingSeparator}sizing=minvalue&value=50`}
          alt=""
          onError={() => setHasImageError(true)}
        />
      ) : (
        <span aria-hidden="true">{initials}</span>
      )}
    </div>
  );
}

